export const CFieldsCollections = {
    ID: 'id',
  } as const;